"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var portfolio_column_model_1 = require("../model/portfolio.column.model");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var DynamicComponenetLoaderComponent = /** @class */ (function () {
    function DynamicComponenetLoaderComponent(loader, _injector, _m) {
        this.loader = loader;
        this._injector = _injector;
        this._m = _m;
    }
    DynamicComponenetLoaderComponent.prototype.ngOnInit = function () {
        this.loadComponent();
    };
    DynamicComponenetLoaderComponent.prototype.loadComponent = function () {
        var _this = this;
        this.loader.load(this.metadata.modulePath).then(function (factory) {
            var module = factory.create(_this._injector);
            var resolver = module.componentFactoryResolver;
            var components = resolver["_factories"];
            var found = false;
            components.forEach(function (value, key) {
                if (value.selector == _this.metadata.componentSelector) {
                    var cmpRef = value.create(_this._injector, [], null, _this._m);
                    cmpRef.instance.data = _this.data;
                    _this._container.insert(cmpRef.hostView);
                    found = true;
                }
            });
            if (!found) {
                console.error('Dynamic componenet with selector name ' + _this.metadata.componentSelector + ' not found in module ' + _this.metadata.modulePath);
            }
        });
    };
    DynamicComponenetLoaderComponent.decorators = [
        { type: core_1.Component, args: [{
                    
                    selector: 'dynamic-component-loader',
                    template: '<div #portfolioDynamicContent></div>'
                },] },
    ];
    /** @nocollapse */
    DynamicComponenetLoaderComponent.ctorParameters = function () { return [
        { type: core_1.NgModuleFactoryLoader, },
        { type: core_1.Injector, },
        { type: core_1.NgModuleRef, },
    ]; };
    DynamicComponenetLoaderComponent.propDecorators = {
        "_container": [{ type: core_1.ViewChild, args: ['portfolioDynamicContent', { read: core_1.ViewContainerRef },] },],
        "data": [{ type: core_1.Input },],
        "metadata": [{ type: core_1.Input },],
    };
    return DynamicComponenetLoaderComponent;
}());
exports.DynamicComponenetLoaderComponent = DynamicComponenetLoaderComponent;
//# sourceMappingURL=dynamic-component-loader.component.js.map